<script>
import { BTabs } from "bootstrap-vue";

export default {
  extends: BTabs
};
</script>